import { render, staticRenderFns } from "./DetailValues.vue?vue&type=template&id=1d2539bc&scoped=true&"
import script from "./DetailValues.vue?vue&type=script&lang=js&"
export * from "./DetailValues.vue?vue&type=script&lang=js&"
import style0 from "./DetailValues.vue?vue&type=style&index=0&id=1d2539bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2539bc",
  null
  
)

export default component.exports